import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const Trash = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <path
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5,6h1v15H5V6z M18,6h1v15h-1V6z M5,21 h14v1H5V21z"
        />
        <path
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15,4V2H9v2H4v1h16V4H15z M14,4h-4V3h4 V4z"
        />
        <g id="eds-icon--trash_lines">
            <rect
                x="9"
                y="8"
                fillRule="evenodd"
                clipRule="evenodd"
                width="1"
                height="11"
            />
            <rect
                x="14"
                y="8"
                fillRule="evenodd"
                clipRule="evenodd"
                width="1"
                height="11"
            />
        </g>
    </svg>
);

export default Trash;
